module.exports = __webpack_public_path__ + "static/img/bkq-logo.65f21bde.png";